var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.7674 0.711643C7.53014 0.271277 8.46987 0.271277 9.2326 0.711643L13.6956 3.28836C14.4583 3.72872 14.9282 4.54255 14.9282 5.42329V10.5767C14.9282 11.4574 14.4583 12.2713 13.6956 12.7116L9.2326 15.2884C8.46987 15.7287 7.53013 15.7287 6.7674 15.2884L2.3044 12.7116C1.54166 12.2713 1.0718 11.4574 1.0718 10.5767V5.42329C1.0718 4.54255 1.54166 3.72872 2.3044 3.28836L6.7674 0.711643Z",
    fill: "#666B7D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.8125 4.26666C6.74496 4.26666 7.50087 5.02257 7.50087 5.95503V11.5036C6.56841 11.5036 5.8125 10.7477 5.8125 9.81522V4.26666Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3457 7.56512C9.27817 7.56512 10.0341 8.32103 10.0341 9.2535V11.7005C9.10161 11.7005 8.3457 10.9446 8.3457 10.0121V7.56512Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooter);
export default __webpack_public_path__ + "static/media/footer.f2914946fb5eeb9d62b1456e3a307c5a.svg";
export { ForwardRef as ReactComponent };